<template>
  <section class="platform-coupon">
    <div class="tree">
      <area-tree
        :moduleName="moduleName"
        v-on:handleTreeClick="handleTreeClick"
        class="clique-tree"
      ></area-tree>
      <merchant-tree
        :groupId="treeData.groupId"
        class="merchant-tree"
        ref="merchantTree"
        v-on:merchantTreeCallback="merchantTreeCallback"
      ></merchant-tree>
    </div>
    <div class="content">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label>券名称:</label>
            <input
              v-model="search.name"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                type="button"
                class="btn btn-primary"
                id="search_btn"
                @click="searchList"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="onAddClick"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>

      <el-table
        border
        height="100%"
        :data="tableListData"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column
          show-overflow-tooltip
          label="优惠券名称"
          prop="name"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="优惠券类型"
          prop="couponTypeName"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="优免值"
          prop="unitPrice"
        ></el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          label="使用时段"
          prop="address"
        ></el-table-column> -->
        <el-table-column
          show-overflow-tooltip
          label="发行有效期"
          prop="activeEndTime"
        >
    <template v-slot="scope">
        <span>{{ scope.row.activeStartTime }}--{{ scope.row.activeEndTime }}</span>
    </template>
    
    </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="发行张数"
          prop="maxUseNum"
        ></el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          label="发行张数"
          prop="address"
        ></el-table-column> -->

        <el-table-column show-overflow-tooltip label="使用有效期">
          <template v-slot="scope">
            <span>{{ scope.row.startTime }}--{{ scope.row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="每人限领"
          prop="ticketNumPerPerson"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="券状态"
          prop="couponStateName"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <button v-bind:class="['edit', 'operate-button',scope.row.couponStatus!='created'||scope.row.disabled?'disabled':'']"  type="button" @click="onIssueClick(scope.row)" :disabled="scope.row.couponStatus!='created'||scope.row.disabled">
              发行
            </button>
            <button class="edit operate-button" v-bind:class="['edit', 'operate-button',scope.row.couponStatus!='issued'||scope.row.disabled?'disabled':'']" type="button" @click="onStopIssuingClick(scope.row)" :disabled="scope.row.couponStatus!='issued'||scope.row.disabled">
              停止发行
            </button>
            <button class="edit operate-button" type="button" @click="onUpdateClick(scope.row)">
              修改
            </button>
            <button class="delete operate-button" type="button" @click="onDeleteClick(scope.row)">
              删除
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
  </section>
</template>
<script>
import {  updateCoupon ,IssueCoupon,stopIssuingCoupon} from "@/api/url";
import { mapState, mapMutations } from "vuex";
import MerchantTree from "./components/MerchantTree/MerchantTree.vue";
import AreaTree from "../../../commons/areaTree.vue";
import Page from "../../../commons/parking/commons/page.vue";
import { couponList } from "@/api/url";
import {COUPON_STATE,COUPON_TYPE}  from '../constant.js'
const dayjs=require('dayjs')
export default {
  name: "platform-coupon",
  components: {
    MerchantTree,
    AreaTree,
    Page,
  },
  data() {
    return {
      moduleName: "property",
      merchant: null,
      treeData: {
        groupId: "",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
      },
      coupons: [],
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListData: [],
      pageObj:{}
    };
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  mounted() {},
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.merchant?.id) {
        this.$message({
          type: "warning",
          message: "请选择商户",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    handleTreeClick: function(node, data) {
      this.treeData.groupId = node.id;
      this.merchant = null;
    },

    merchantTreeCallback(node) {
      this.merchant = node;

      this.tableList(1);
    },
    tableList(curPage) {
      this.$get(couponList(), {
        limit: this.search.pageSize,
        page: curPage,
        shopsId: this.merchant?.id ?? "",
      }).then((data) => {
        if (data.status != 200) return;
        //翻页

        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.pageObj={...pageObj}
        // this.getPage(pageObj);
        this.tableListData = data?.data?.rows.map(item=>{
          item.disabled=dayjs(item.activeEndTime).valueOf()<dayjs().valueOf();
         
          item.couponStateName=COUPON_STATE.find(state=>state.value==item.couponStatus)?.label;
          item.couponTypeName=COUPON_TYPE.find(type=>type.value==item.couponType)?.label;
          return item;
        });
      });
    },
    searchList: function() {
      if (!this.merchant?.id) {
        this.$message({
          type: "warning",
          message: "请选择商户",
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    onAddClick() {
      if (!this.merchant) {
        this.$message({
          type: "warning",
          message: "请选择商户",
        });
        return;
      }
      this.$router.push({
        path: "/main/coupon/update-platform-coupon",
        query: { id: this.merchant?.id,type:'add' },
      });
    },
    onUpdateClick(row){
        this.$router.push({
            path:"/main/coupon/update-platform-coupon",
            query:{
              type:'edit',
              coupon:row?.couponRuleDesc,
              discountsBaseId:row?.discountsBaseId,
              name:row?.name,couponShopId:row?.couponShopId
            }
        })
    },
    onIssueClick(row){
        const {couponStatus,activeEndTime,couponShopId}=row;
        if(couponStatus==="created"&&dayjs(row.activeEndTime).valueOf()>dayjs().valueOf()){
            this.$postRequest(`${IssueCoupon()}?couponShopId=${couponShopId}`).then(data=>{
            if(data?.status!=200) {
                this.$notify({
                type: "warning",
                title: "发行失败",
                message: data.message,
              });
                return;
            }
            this.$notify({
                type: "success",
                title: "成功",
                message: "发行成功！",
              });
              this.tableList(this.pageObj.curIndex)
            })
        }

    },
    onStopIssuingClick(row){
        const {couponStatus,couponShopId}=row;
            if(couponStatus==="issued"&&dayjs(activeEndTime).valueOf()>dayjs().valueOf()){
            this.$postRequest(`${stopIssuingCoupon()}`,{couponShopId}).then(data=>{
            if(data?.status!=200) {
                this.$notify({
                type: "warning",
                title: "停止发行失败",
                message: data.message,
              });
                return;
            }
            this.$notify({
                type: "success",
                title: "停止发行成功",
                message: "停止发行成功！",
              });
              this.tableList(this.pageObj.curIndex)
            })
        }

        
    },
    onDeleteClick(row){
        var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this
            .$deleteRequest(updateCoupon() + "/" + row.couponShopId )
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功！",
              });
              _this.tableList(_this.pageObj.curIndex);
            });
        }
      );
    }
  },
};
</script>
<style lang="scss">
.platform-coupon {
  display: flex;
  justify-content: flex-start;
  .tree {
    display: flex;
    justify-content: flex-start;
    .clique-tree {
      width: 180px;
    }
    .merchant-tree {
      width: 180px;
    }
  }
  .content {
    width: calc(100% - 360px);
    .el-table {
    }
  }
  .disabled{
    cursor:not-allowed;
    color: #aaa !important;;
  }
}
</style>
